import type { BadgeVariant } from '../../components/ui';
import type { KhoaDich } from '../../i18n';
import type { DocStatus, LiveStage } from './types';

/**
 * Nhãn và tông màu của phân hệ `xu-ly` (chứng từ OCR).
 *
 * Màu là **quyết định trình bày**, không phải dữ liệu, nên ở đây chứ không ở `src/mock/`.
 *
 * ## Luật màu trạng thái, dùng chung toàn kho
 *
 * | Tông | Nghĩa |
 * | --- | --- |
 * | `success` | đã xong, đã xác nhận |
 * | `warning` | đang chờ người làm gì đó |
 * | `danger` | lỗi, cần người vào xem |
 * | `primary` | hệ thống đang chạy |
 * | `neutral` | chưa bắt đầu, đã kết thúc không cần quan tâm |
 *
 * Chỉ dùng nhóm **trạng thái** của `Badge`. Bản trước tô `TRANSFERRED` và các giai đoạn bằng tông
 * phân loại (`violet`, `info`) — dùng lẫn hai nhóm, CLAUDE.md cấm. `TRANSFERRED` là đã kết thúc,
 * không cần ai làm gì nữa nên `neutral`; các giai đoạn đang chạy là `primary`, khác nhau ở chữ.
 */
export const STATUS_CONFIG: Record<DocStatus, { khoa: KhoaDich; variant: BadgeVariant }> = {
  DRAFT: { khoa: 'chungTu.trangThai.DRAFT', variant: 'neutral' },
  PROCESSING: { khoa: 'chungTu.trangThai.PROCESSING', variant: 'primary' },
  PROCESSED: { khoa: 'chungTu.trangThai.PROCESSED', variant: 'warning' },
  CONFIRMED: { khoa: 'chungTu.trangThai.CONFIRMED', variant: 'success' },
  TRANSFERRED: { khoa: 'chungTu.trangThai.TRANSFERRED', variant: 'neutral' },
  ERROR: { khoa: 'chungTu.trangThai.ERROR', variant: 'danger' },
};

/** Giai đoạn của lượt quét đang chạy; phần trăm là ước lượng cho thanh tiến trình. */
export const STAGE_CONFIG: Record<LiveStage, { khoa: KhoaDich; variant: BadgeVariant; phanTram: number }> = {
  QUEUED: { khoa: 'chungTu.giaiDoan.QUEUED', variant: 'neutral', phanTram: 8 },
  READING: { khoa: 'chungTu.giaiDoan.READING', variant: 'primary', phanTram: 38 },
  READ_DONE: { khoa: 'chungTu.giaiDoan.READ_DONE', variant: 'primary', phanTram: 62 },
  MAPPING: { khoa: 'chungTu.giaiDoan.MAPPING', variant: 'primary', phanTram: 84 },
  RETRY_WAIT: { khoa: 'chungTu.giaiDoan.RETRY_WAIT', variant: 'warning', phanTram: 45 },
};

/** Trạng thái cho thao tác (bản TypeScript của `document.stage.ts`): view dùng để **ẩn** mục. */
export const SUA_DUOC: readonly DocStatus[] = ['DRAFT', 'PROCESSED'];
export const XOA_DUOC: readonly DocStatus[] = ['DRAFT', 'PROCESSING', 'PROCESSED', 'ERROR'];
export const QUET_LAI_DUOC: readonly DocStatus[] = ['DRAFT', 'PROCESSED', 'ERROR'];
